// extracted by mini-css-extract-plugin
export default {"root":"j9tnP","stat":"_2Q1R_","label":"_24hEY"};